module.exports = __webpack_public_path__ + "static/media/remove-icon.2e649f25.svg";